import * as RadixDialog from '@radix-ui/react-dialog'
import styled, { keyframes } from 'styled-components'

const overlayShow = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`

export const DialogOverlay = styled(RadixDialog.Overlay)`
  background: var(--appearanceA-5);
  backdrop-filter: blur(5px);

  position: fixed;
  inset: 0;
  animation: ${overlayShow} 150ms cubic-bezier(0.16, 1, 0.3, 1);
`
